<template>
    <div id="product_modal" class="ui middle aligned center aligned grid" v-if="showModal">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <div class="ui text menu">
                    <div class="item">
                        <h3 class="ui header">{{ partner.name }} 날짜별 재고</h3>
                    </div>
                    <div class="right menu">
                        <div class="item">
                            <div class="ui form">
                                <div class="ui calendar" id="calendar" :data-date="date" :data-max-date="date">
                                    <div class="ui input left icon">
                                        <i class="calendar icon"></i>
                                        <input type="text" placeholder="날짜">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="ui teal small button" @click="download">다운로드</div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="body" class="ui segment">
                <table class="ui selectable very basic compact table">
                    <thead>
                        <tr>
                            <th class="collapsing">#</th>
                            <th class="collapsing">규격</th>
                            <th>상품명</th>
                            <th v-for="center in centers" :key="center._id">{{ center.name }}</th>
                            <th>합계</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, index) in products" :key="product._id">
                            <td class="collapsing">{{ index+1 }}</td>
                            <td class="collapsing">{{ product.description }}</td>
                            <td>{{ product.name }}</td>
                            <td v-for="center in centers" :key="center._id">
                                {{ product.stockLogs[dateKey][center._id] }}
                            </td>
                            <td>
                                {{ productTotalCounts[product._id] }}
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>전체합계</td>
                            <td v-for="center in centers" :key="center._id">
                                {{ centerTotalCounts[center._id] }}
                            </td>
                            <td>{{ getAllTotalCount() }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui text menu">
                    <div class="right menu">
                        <div class="item">
                            <div class="ui small button" @click="close">닫기</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            showModal: 0, 
            partner: 0,
            products: 0,
            productTotalCounts: 0,
            centerTotalCounts: 0,
            date: 0,
            dateKey: 0,
            centers: 0,
        }
    },
    created: function() {
        this.showModal = false;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("openProductStockLog", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("openProductStockLog");
    },
    methods: {
        open(_partnerId, allProducts) {
            const today = new Date();
            this.date = new Date(today.getFullYear(), today.getMonth(), today.getDate()-1);
            this.dateKey = (this.date.getMonth()+1) + "/" + this.date.getDate();
            this.showModal = true;
            this.products = this.getProducts(allProducts);
            this.centers = this.getCenters();
            this.partner = this.partners.find((p, i) => p._id == _partnerId);
            this.productTotalCounts = {};
            this.centerTotalCounts = {};
            this.updateTotalCount();
            this.$nextTick(() => {
                this.$ui.calendar("#calendar", (date, text) => {
                    this.date = date;
                });
            });
        },
        close() {
            this.showModal = false;
        },
        updateTotalCount() {
            for (const product of this.products) {
                let sum = 0;
                for (const center of this.centers) {
                    if (!product.stockLogs) product.stockLogs = {};
                    if (!product.stockLogs[this.dateKey]) product.stockLogs[this.dateKey] = {};
                    if (!product.stockLogs[this.dateKey][center._id]) product.stockLogs[this.dateKey][center._id] = 0;
                    sum += product.stockLogs[this.dateKey][center._id];
                }
                this.productTotalCounts[product._id] = sum;
            }
            for (const center of this.centers) {
                let sum = 0;
                for (const product of this.products) {
                    sum += product.stockLogs[this.dateKey][center._id];
                }
                this.centerTotalCounts[center._id] = sum;
            }
        },
        getAllTotalCount() {
            let sum = 0;
            for (const center of this.centers) {
                sum += this.centerTotalCounts[center._id];
            }
            return sum;
        },
        download() {
            const aoa = [];
            const titleRow = [];
            {
                titleRow.push("#");
                titleRow.push("규격");
                titleRow.push("상품명");
                for (const center of this.centers) { titleRow.push(center.name); }
                titleRow.push("합계");
            }
            aoa.push(titleRow);

            let index = 1;
            for (const product of this.products)
            {
                const row = [];
                row.push(index++);
                row.push(product.description);
                row.push(product.name);
                for (const center of this.centers) { row.push(product.stockLogs[this.dateKey][center._id]); }
                row.push(this.productTotalCounts[product._id]);
                aoa.push(row);
            }

            let sumRow = [];
            {
                sumRow.push("");
                sumRow.push("");
                sumRow.push("합계");
                for (const center of this.centers) { sumRow.push(this.centerTotalCounts[center._id]); }
                sumRow.push(this.getAllTotalCount());
            }
            aoa.push(sumRow);

            const wb = this.$excel.newWorkBook();
            const ws = this.$excel.addWorkSheet(wb, "sheet", aoa);
            this.$excel.setColSizes(ws, [ 4, 10, 30, 10, 10, 10, 10, 10, 10, 10, 10 ]);
            this.$excel.saveFile(wb, this.date.format("yyyyMMdd_") + this.partner.name + "_재고");
        },
        getProducts(allProducts)
        {
            const array = [];
            for (const product of allProducts)
            {
                if (!product.isTerminated) array.push(product);
            }
            return array;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.storeCenters)
            {
                if (!center.isTerminated) array.push(center);
            }
            return array;
        },
    },
    computed: {
        partners: function() { return this.$store.getters.partners; },
        storeCenters: function() { return this.$store.getters.centers; },
    },
    watch: {
        date: function(val) {
            this.dateKey = (val.getMonth()+1) + "/" + val.getDate();
            this.updateTotalCount();
        }
    }
}
</script>

<style>

#product_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#product_modal .column {
    max-width: 800px;
}

#product_modal #header {
    padding: 20px 30px;
}

#product_modal #header .menu {
    margin: 0;
    padding: 0;
}

#product_modal #header .ui.form {
    margin: 0;
    padding: 0;
}

#product_modal #body {
    padding: 30px;
    font-size: 13px;
}

#product_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#product_modal #footer .ui.menu {
    margin: 0;
}

#product_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductModal_DailyLog.vue